export default __webpack_public_path__ + "static/media/ofertas-encerradas.789b5baa.pdf";